import { memo } from 'react'
import Skeleton from './Skeleton'

function TableSkeleton({ index, count }) {
  const arr = new Array(count).fill(NaN)

  return (
    <tr key={index} className="border-b border-b-light-gray dark:border-b-gray-700">
      {arr.map((item, indx) => (
        <td key={indx} className="px-6 py-4">
          <Skeleton />
        </td>
      ))}
    </tr>
  )
}

export default memo(TableSkeleton)
